import { createSlice } from '@reduxjs/toolkit';

// utils
import socket from '../../utils/socket';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false
};

const slice = createSlice({
  name: 'nfcCards',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.error = action.payload;
      console.error(state.error);
      state.isLoading = false;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function postNfcResource({ nfcUid, resourceId }) {
  return socket.post('/nfc_cards/resource', {
    nfcUid,
    resourceId
  });
}
